module.exports = __webpack_public_path__ + "static/media/news-12.ba1a3ed3.jpg";